import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("ServiceErrorMessage")
export class ServiceErrorMessage {

  key: string;

  message: string;
}
